'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_credentials$package$() {
  this.gI = null;
  $n_Lpresto_credentials$package$ = this;
  this.gI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "Invalid Request"));
}
export { $c_Lpresto_credentials$package$ as $c_Lpresto_credentials$package$ };
$p = $c_Lpresto_credentials$package$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_credentials$package$;
/** @constructor */
function $h_Lpresto_credentials$package$() {
}
export { $h_Lpresto_credentials$package$ as $h_Lpresto_credentials$package$ };
$h_Lpresto_credentials$package$.prototype = $p;
var $d_Lpresto_credentials$package$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_credentials$package$, "presto.credentials$package$", ({
  Vp: 1
}));
export { $d_Lpresto_credentials$package$ as $d_Lpresto_credentials$package$ };
var $n_Lpresto_credentials$package$;
function $m_Lpresto_credentials$package$() {
  if ((!$n_Lpresto_credentials$package$)) {
    $n_Lpresto_credentials$package$ = new $c_Lpresto_credentials$package$();
  }
  return $n_Lpresto_credentials$package$;
}
export { $m_Lpresto_credentials$package$ as $m_Lpresto_credentials$package$ };
//# sourceMappingURL=presto.credentials$package$.js.map
